import { getAccountTimezone } from '@/store/account/timezone-cache';
import { getCompareDateRange } from '@/lib/helpers/dates/date-ranges';

import { DEFAULT_COMPARE_PRESET } from '../../constants/dashboard-filter-constants';
import { rememberUnifiedViewId } from '../../helpers/unified-view-session-tracker';

import type { CompareActions, ImmerSet } from '../../types/filter-actions-types';

// ---------------------------------------------------------------------------
// Actions
// ---------------------------------------------------------------------------

export function createCompareActions(set: ImmerSet): CompareActions {
  return {
    toggleCompare: (viewId, isEnabled) => {
      set(state => {
        const view = state.views[viewId];
        if (!view) return;

        const timezone = getAccountTimezone();
        view.enableCompareDate = isEnabled;

        if (isEnabled) {
          const primaryDateRangeIsValid =
            view.dateRange && view.dateRange.start && view.dateRange.end;

          if (primaryDateRangeIsValid) {
            if (!view.comparePreset || view.comparePreset === 'custom') {
              view.comparePreset = DEFAULT_COMPARE_PRESET;
            }
            view.compareDateRange = getCompareDateRange(
              view.dateRange,
              view.comparePreset,
              timezone
            );
          } else {
            view.compareDateRange = null;
          }
        } else {
          view.compareDateRange = null;
          view.comparePreset = null;
        }
      });
      rememberUnifiedViewId(viewId);
    },

    setComparePreset: (viewId, comparePresetName) => {
      set(state => {
        const view = state.views[viewId];
        if (!view) return;

        const timezone = getAccountTimezone();
        view.comparePreset = comparePresetName;

        if (!view.enableCompareDate) {
          view.compareDateRange = null;
          return;
        }

        const primaryDateRangeIsValid =
          view.dateRange && view.dateRange.start && view.dateRange.end;

        if (!comparePresetName) {
          view.compareDateRange = null;
        } else if (comparePresetName === 'custom') {
          view.comparePreset = 'custom';
        } else {
          if (primaryDateRangeIsValid) {
            view.compareDateRange = getCompareDateRange(
              view.dateRange,
              comparePresetName,
              timezone
            );
          } else {
            view.compareDateRange = null;
          }
        }
      });
      rememberUnifiedViewId(viewId);
    },

    setCustomCompareDateRange: (viewId, range) => {
      set(state => {
        const view = state.views[viewId];
        if (!view) return;

        if (!range?.start || !range?.end) {
          view.compareDateRange = null;
          view.comparePreset = null;
        } else {
          view.compareDateRange = range;
          view.comparePreset = 'custom';
          if (!view.enableCompareDate) {
            view.enableCompareDate = true;
          }
        }
      });
      rememberUnifiedViewId(viewId);
    },
  };
}
